import { chain, assign, zipObject, isFunction } from "lodash"

const RX_CAPS = /(?!^)([A-Z])/g

// converts a camelCaseWord into a SCREAMING_SNAKE_CASE word
function camelToScreamingSnake(str) {
  return str.replace(RX_CAPS, "_$1").toUpperCase()
}

function getMeta(result, params, options) {
  let track = params.track != null ? params.track : options.track
  let trackType = params.trackType || options.trackType
  const updatePreference = params.updatePreference

  if (isFunction(track)) {
    track = track(result)
  }

  if (isFunction(trackType)) {
    trackType = trackType(result)
  }

  let meta = null
  if (track) {
    meta = { ...meta, track, trackPayload: params.trackPayload || options.trackPayload, trackType }
  }

  if (updatePreference) {
    meta = { ...meta, updatePreference }
  }

  return meta
}

function createActionCreator(name, type, params, options) {
  let props

  if (Array.isArray(params) || isFunction(params)) {
    props = params
  } else {
    props = params.props
  }

  return (...values) => {
    const extraProps = isFunction(props)
      ? props(...values)
      : zipObject(props, values)

    const result = { type, ...extraProps }

    const meta = getMeta(result, params, options)
    if (meta) {
      result.meta = meta
    }
    return result
  }
}

export default function createActions(prefix, actions, options = {}) {
  return {
    Creators: chain(actions)
      .keys()
      .map(key => {
        const screamingKey = camelToScreamingSnake(key)
        const type = `${prefix}/${screamingKey}`
        return {
          [key]: createActionCreator(key, type, actions[key], options),
        }
      })
      .thru(keys => assign(...keys))
      .value(),
    Types: chain(actions)
      .keys()
      .map(key => {
        const screamingKey = camelToScreamingSnake(key)
        const type = `${prefix}/${screamingKey}`
        return {
          [screamingKey]: type,
        }
      })
      .thru(keys => assign(...keys))
      .value(),
  }
}
